import { type PropsWithChildren } from 'react';
import { cn } from '@/utils';
import { ClassroomSelector } from './ClassroomSelector';
import { SideBarFooter } from './SideBarFooter';
import { Tabs } from './Tabs';
export const SideBar = () => {
  return <SideBarContainer className="shrink-0" data-sentry-element="SideBarContainer" data-sentry-component="SideBar" data-sentry-source-file="SideBar.tsx">
      <div className="flex h-full flex-col justify-between">
        <div>
          <ClassroomSelector data-sentry-element="ClassroomSelector" data-sentry-source-file="SideBar.tsx" />
          <Tabs data-sentry-element="Tabs" data-sentry-source-file="SideBar.tsx" />
        </div>
        <SideBarFooter data-sentry-element="SideBarFooter" data-sentry-source-file="SideBar.tsx" />
      </div>
    </SideBarContainer>;
};
const SideBarContainer = ({
  className,
  children
}: PropsWithChildren<{
  className?: string;
}>) => <aside className={cn('shadow-sm bg-opacity-white-9 z-10 w-[250px] pt-xl pr-md pb-2xl pl-[40px]', className)} data-sentry-component="SideBarContainer" data-sentry-source-file="SideBar.tsx">
    {children}
  </aside>;